module.exports = __webpack_public_path__ + "img/darksearchicon.4a545a49.svg";